// extracted by mini-css-extract-plugin
var _1 = "center--gfhynFk";
var _2 = "info-section--dUFf74L";
var _3 = "list--WlXIic0";
export { _1 as "center", _2 as "infoSection", _3 as "list" }
